import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { Divider } from 'antd'
import PerText from '../../../components/custom_components/Text'
import { ObjectiveStatus, ObjectiveDto, KeyResultDto } from '../../../types'
import { Table } from 'antd'
import { filterObjectivesByTypeStatusAndRefYear } from './util'
import PerFlexRow from '../../../components/custom_components/FlexRow'
import PerIcon from '../../../components/custom_components/Icon'

interface Props {
  objectives: ObjectiveDto[]
}
export const ConclusionDevelopmentObjectives: FC<Props> = ({ objectives }) => {
  const [t] = useTranslation()
  const developmentObjectives = filterObjectivesByTypeStatusAndRefYear(objectives, false, [ObjectiveStatus.MarkedAsDone])

  const generateKeyResults = (keyResults: KeyResultDto[]) =>
    keyResults.map((kr: KeyResultDto, index: number) => (
      <PerFlexRow align="middle" mb="xxxs" key={index} noWrap>
        <div style={{ width: '20px', textAlign: 'center' }} className="per-flexRow--fixed">
          <PerIcon
            name={kr.completed ? 'check_stroke' : 'circle_fill'}
            color={kr.completed ? 'primary' : 'secondary'}
            size={kr.completed ? 18 : 8}
          />
        </div>
        <PerText color={kr.completed ? 'default' : 'secondary'} ml="xxs" className="per-flexRow--growShrink">
          {kr.text}
        </PerText>
      </PerFlexRow>
    ))

  const columns = [
    {
      key: 'title',
      title: t('appraisalMeeting.closedTargetsOverview.table.title.development'),
      dataIndex: 'title',
      render: (title: string) => <PerText fontWeight="bold">{title}</PerText>,
    },
    {
      key: 'keyResults',
      title: t('appraisalMeeting.closedTargetsOverview.table.title.tasks'),
      dataIndex: 'keyResults',
      render: (keyResults: KeyResultDto[]) => generateKeyResults(keyResults),
    },
  ]

  return (
    <>
      {developmentObjectives.length > 0 && (
        <div data-e2e-development-conclusion>
          <PerText appearance="heading" color="primary" my="m">
            {t('appraisalMeeting.conclusion.pastDevelopmentTargets')}
          </PerText>

          <Table rowKey="globalId" dataSource={developmentObjectives} columns={columns} pagination={false} />
          <Divider />
        </div>
      )}
    </>
  )
}
